import React from 'react';
import clsx from 'clsx';
import styles from '../FundingHistory.module.scss';
import {
    FUNDING_AMOUNT_HEADER_ID,
    FUNDING_TYPE_HEADER_ID,
    INSTRUMENT_HEADER_ID,
    PREMIUM_NOMINAL_HEADER_ID,
    RUPEE_PREFIX,
} from '../constants';

interface FundingTableRowProps {
    data: any;
    headers: Array<{ id: string; label: string }>;
    isPDFReport: boolean;
}

const DARK_TEXT_HEADER_IDS = [INSTRUMENT_HEADER_ID, FUNDING_TYPE_HEADER_ID];

function FundingTableRow({ data, headers, isPDFReport }: FundingTableRowProps) {
    const getRowItem = (headerId: string, fundingData: any) => {
        switch (headerId) {
            case PREMIUM_NOMINAL_HEADER_ID:
                return (
                    <PremiumNominalCell premium={fundingData?.premiumAmountPerSecurity} nominal={fundingData?.nominalAmountPerSecurity} />
                );
            default: {
                const value = fundingData?.[headerId];
                if (value == null) return '-';
                return !isPDFReport && headerId === FUNDING_AMOUNT_HEADER_ID ? `${RUPEE_PREFIX}${value}` : value;
            }
        }
    };

    return (
        <div className={styles.tableRow}>
            {headers.map((header) => {
                const rowItem = getRowItem(header.id, data);
                return (
                    <div
                        key={header.id}
                        className={clsx(styles.rowItem, {
                            [styles.alignRight]: isPDFReport && header.id === FUNDING_AMOUNT_HEADER_ID,
                            [styles.amountCell]: !isPDFReport && header.id === FUNDING_AMOUNT_HEADER_ID,
                            [styles.darkCell]: !isPDFReport && DARK_TEXT_HEADER_IDS.includes(header.id),
                        })}
                        title={!isPDFReport && typeof rowItem === 'string' ? rowItem : undefined}
                    >
                        {rowItem}
                    </div>
                );
            })}
        </div>
    );
}

export default FundingTableRow;

function PremiumNominalCell({ premium, nominal }: { premium?: string; nominal?: string }) {
    if (premium == null && nominal == null) return <>-</>;
    return (
        <>
            {premium ?? '-'} / <span className={styles.nominalValue}>{nominal ?? '-'}</span>
        </>
    );
}
